<template>
<div>
    <Pedido />
    	<div v-if="show" :class="containerClass" @click="onWrapperClick">
        <AppTopBar @menu-toggle="onMenuToggle" />
        <div class="layout-sidebar" @click="onSidebarClick">
            <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
        </div>

        <div class="layout-main-container">
            <div class="layout-main">
                <router-view />
            </div>
            <AppFooter />
        </div>

		<AppConfig :layoutMode="layoutMode" @layout-change="onLayoutChange" @change-theme="changeTheme" />
        <transition name="layout-mask">
            <div class="layout-mask p-component-overlay" v-if="mobileMenuActive"></div>
        </transition>
	</div> 
    </div>
</template>

<script>
import Pedido from './pages/faça-seu-pedido.vue'
import AppTopBar from './AppTopbar.vue';
import AppMenu from './AppMenu.vue';
import AppConfig from './AppConfig.vue';
import AppFooter from './AppFooter.vue';

export default {
    emits: ['change-theme'],
    
    data() {
        return {
            show: false,
            layoutMode: 'static',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            menu : [
                {
                    label: 'Home',
                    items: [{
                        label: 'Painel de Controle', icon: 'pi pi-fw pi-home', to: '/dashboard'
                    }]
                },
				{
					label: 'Páginas', icon: 'pi pi-fw pi-clone',
					items: [
						{label: 'Cadastro', icon: 'pi pi-fw pi-user-edit', to: '/crud'},
						{label: 'Linha do tempo', icon: 'pi pi-fw pi-calendar', to: '/timeline'},
                        {label: 'Landing', icon: 'pi pi-fw pi-globe', to: '/landing'},
                        {label: 'Faça Seu Pedido', icon: 'pi pi-fw pi-heart-fill', to: '/faça-seu-pedido'},
                        {label: 'Product', icon: 'pi pi-fw pi-heart-fill', to: '/product'},
                        {label: 'carrinho', icon: 'pi pi-fw pi-shopping-cart', to: '/carrinho'},
                        {label: 'Login', icon: 'pi pi-fw pi-sign-in', to: '/login'},
                 /*        {label: 'Error', icon: 'pi pi-fw pi-times-circle', to: '/error'},
                        {label: 'Sem acesso', icon: 'pi pi-fw pi-exclamation-circle', to: '/notfound'},
                        {label: 'Accesso', icon: 'pi pi-fw pi-lock', to: '/access'},
						{label: 'Vázio', icon: 'pi pi-fw pi-circle-off', to: '/empty'},*/
					]
				},
                {
					label: 'Relatórios', icon: 'pi pi-fw pi-chart-bar',
					items: [
                        {label: 'Gráficos', icon: 'pi pi-fw pi-chart-bar', to: '/chart'},
					]
				},
                {
					label: 'Clientes', icon: 'pi pi-fw pi-chart-bar',
					items: [
                        {label: 'Disparo para clientes', icon: 'pi pi-fw pi-chart-bar', to: '/chart'},
                        {label: 'Relatório de Clientes API', icon: 'pi pi-fw pi-chart-bar', to: '/relatorioapi'},
					]
				},
				{
					label: 'Gestão', icon: 'pi pi-fw pi-sitemap',
					items: [
                        {label: 'Gráficos', icon: 'pi pi-fw pi-chart-bar', to: '/chart'},
                        {label: 'Tabela', icon: 'pi pi-fw pi-table', to: '/table'},
						{label: 'Listas', icon: 'pi pi-fw pi-list', to: '/list'},
                        {label: 'Compra de Parceiros', icon: 'pi pi-fw pi-shopping-cart', to: '/shopfriend'},
						{label: 'Gráficos', icon: 'pi pi-fw pi-chart-bar', to: '/chart'},
						{label: 'Misturados', icon: 'pi pi-fw pi-circle-off', to: '/misc'},
					/*	{label: 'Layout de Formulário', icon: 'pi pi-fw pi-id-card', to: '/'},
						{label: 'Input', icon: 'pi pi-fw pi-check-square', to: '/input'},
                        {label: "Formulário", icon: "pi pi-fw pi-bookmark", to: "/floatlabel"},
                        {label: "Estado inválido", icon: "pi pi-fw pi-exclamation-circle", to: "/invalidstate"},
						{label: 'Botões', icon: 'pi pi-fw pi-mobile', to: '/button'},
                        {label: 'Pedidos', icon: 'pi pi-fw pi-list', to: '/pedidos'},
						{label: 'Arvores', icon: 'pi pi-fw pi-share-alt', to: '/tree'}, 
						{label: 'Painel', icon: 'pi pi-fw pi-tablet', to: '/panel'},
					 	{label: 'Sobreposição', icon: 'pi pi-fw pi-clone', to: '/overlay'},
                        {label: "Galeria", icon: "pi pi-fw pi-image", to: "/media"},
						{label: 'Menu', icon: 'pi pi-fw pi-bars', to: '/menu'},
						{label: 'Mensagens', icon: 'pi pi-fw pi-comment', to: '/messages'},
						{label: 'Arquivos', icon: 'pi pi-fw pi-file', to: '/file'},*/
					]
				}, 
               /* {
                    label: 'PrimeBlocks',
                    items: [
                        {label: 'Blocos Gratuítos', icon: 'pi pi-fw pi-eye', to: '/blocks', badge: "NEW"},
                        {label: 'Todos Blocos', icon: 'pi pi-fw pi-globe', url: 'https://www.primefaces.org/primeblocks-vue', target: '_blank'}
                    ]
                },*/
               /* {
                    label: 'Utilities',
                    items: [
                        {label: 'PrimeIcons', icon: 'pi pi-fw pi-prime', to: '/icons'},
                        {label: 'PrimeFlex', icon: 'pi pi-fw pi-desktop', url: 'https://www.primefaces.org/primeflex/', target: '_blank'},
                    ]
                },*/
                {
					label: 'Marketplace', icon: 'pi pi-fw pi-chart-bar',
					items: [
                        {label: 'Produtos', icon: 'pi pi-fw pi-heart-fill', to: '/foodburguer'},
                        {label: 'Serviços', icon: 'pi pi-fw pi-chart-bar', to: '/chart'},
					]
				},
                {
					label: 'Designs', icon: 'pi pi-fw pi-chart-bar',
					items: [
                        {label: 'Design de Café', icon: 'pi pi-fw pi-heart-fill', to: '/designCoffe'},
                        {label: 'Design de Bebidas', icon: 'pi pi-fw pi-chart-bar', to: '/designBebida'},
                        {label: 'Design de Perfume', icon: 'pi pi-fw pi-chart-bar', to: '/designPerfume'},
					]
				},
                {
					label: 'Configurações', icon: 'pi pi-fw pi-chart-bar',
					items: [
                        {label: 'Disparo para clientes', icon: 'pi pi-fw pi-chart-bar', to: '/chart'},
                        {label: 'Idiomas', icon: 'pi pi-fw pi-circle-off', to: '/misc'},
					]
				},
            /*     {
                    label: 'Menu Hierarchy', icon: 'pi pi-fw pi-search',
                    items: [
                        {
                            label: 'Submenu 1', icon: 'pi pi-fw pi-bookmark',
                            items: [
                                {
                                    label: 'Submenu 1.1', icon: 'pi pi-fw pi-bookmark',
                                    items: [
                                        {label: 'Submenu 1.1.1', icon: 'pi pi-fw pi-bookmark'},
                                        {label: 'Submenu 1.1.2', icon: 'pi pi-fw pi-bookmark'},
                                        {label: 'Submenu 1.1.3', icon: 'pi pi-fw pi-bookmark'},
                                    ]
                                },
                                {
                                    label: 'Submenu 1.2', icon: 'pi pi-fw pi-bookmark',
                                    items: [
                                        {label: 'Submenu 1.2.1', icon: 'pi pi-fw pi-bookmark'},
                                        {label: 'Submenu 1.2.2', icon: 'pi pi-fw pi-bookmark'}
                                    ]
                                },
                            ]
                        },
                        {
                            label: 'Submenu 2', icon: 'pi pi-fw pi-bookmark',
                            items: [
                                {
                                    label: 'Submenu 2.1', icon: 'pi pi-fw pi-bookmark',
                                    items: [
                                        {label: 'Submenu 2.1.1', icon: 'pi pi-fw pi-bookmark'},
                                        {label: 'Submenu 2.1.2', icon: 'pi pi-fw pi-bookmark'},
                                        {label: 'Submenu 2.1.3', icon: 'pi pi-fw pi-bookmark'},
                                    ]
                                },
                                {
                                    label: 'Submenu 2.2', icon: 'pi pi-fw pi-bookmark',
                                    items: [
                                        {label: 'Submenu 2.2.1', icon: 'pi pi-fw pi-bookmark'},
                                        {label: 'Submenu 2.2.2', icon: 'pi pi-fw pi-bookmark'}
                                    ]
                                }
                            ]
                        }
                    ]
                },*/
                /*{
                    label: 'Começando como Dev', 
                    items: [
                        {label: 'Documentação', icon: 'pi pi-fw pi-question', command: () => {window.location = "#/documentation"}},
                        {label: 'Veja o repositório', icon: 'pi pi-fw pi-search', command: () => {window.location = "https://github.com/primefaces/sakai-vue"}}
                    ]
                }*/
            ]
        }
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        }
    },
    methods: {
        onWrapperClick() {
            if (!this.menuClick) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }

            this.menuClick = false;
        },
        onMenuToggle() {
            this.menuClick = true;

            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
					if(this.mobileMenuActive === true) {
						this.overlayMenuActive = true;
					}

                    this.overlayMenuActive = !this.overlayMenuActive;
					this.mobileMenuActive = false;
                }
                else if (this.layoutMode === 'static') {
                    this.staticMenuInactive = !this.staticMenuInactive;
                }
            }
            else {
                this.mobileMenuActive = !this.mobileMenuActive;
            }

            event.preventDefault();
        },
        onSidebarClick() {
            this.menuClick = true;
        },
        onMenuItemClick(event) {
            if (event.item && !event.item.items) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }
        },
		onLayoutChange(layoutMode) {
			this.layoutMode = layoutMode;
		},
        addClass(element, className) {
            if (element.classList)
                element.classList.add(className);
            else
                element.className += ' ' + className;
        },
        removeClass(element, className) {
            if (element.classList)
                element.classList.remove(className);
            else
                element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        isDesktop() {
            return window.innerWidth >= 992;
        },
        isSidebarVisible() {
            if (this.isDesktop()) {
                if (this.layoutMode === 'static')
                    return !this.staticMenuInactive;
                else if (this.layoutMode === 'overlay')
                    return this.overlayMenuActive;
            }

            return true;
        },
        changeTheme(event) {
            this.$emit('change-theme', event);
        }
    },
    computed: {
        containerClass() {
            return ['layout-wrapper', {
                'layout-overlay': this.layoutMode === 'overlay',
                'layout-static': this.layoutMode === 'static',
                'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                'layout-mobile-sidebar-active': this.mobileMenuActive,
				'p-input-filled': this.$primevue.config.inputStyle === 'filled',
				'p-ripple-disabled': this.$primevue.config.ripple === false
            }];
        },
        logo() {
            return (this.$appState.darkTheme) ? "images/logo-white.svg" : "images/logo.svg";
        }
    },
    beforeUpdate() {
        if (this.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    },
    components: {
        'AppTopBar': AppTopBar,
        'AppMenu': AppMenu,
        'AppConfig': AppConfig,
        'AppFooter': AppFooter,
        Pedido
    }
}
</script>

<style lang="scss">
@import './App.scss';
</style>
